import React from 'react'
import CaseStudyComponent from '../../Components/CaseStuduyComponent/CaseStudyComponent'
import FormComponent from '../../Components/ContactComponent/FormComponent'
import ExportsComponent from '../../Components/ExporstComponent/ExportsComponent'
import Footer from '../../Components/Footer/Footer'
import Header from '../../Components/Header/Header'
import HeroCompoentGlobal from '../../Components/HeroComponent/HeroCompoentGlobal'
import TestimonialComponent from '../../Components/TestimonialComponent/TestimonialComponent'
import useDocumentTitle from '../../PageTitle'

const CaseStudy = () => {
  useDocumentTitle("TROO Consulting CaseStudy")
  return (
    <div>
        <Header/>
        <HeroCompoentGlobal/>
        <CaseStudyComponent/>
        <ExportsComponent/>
        <TestimonialComponent/>
        <FormComponent/>
        <Footer/>
    </div>
  )
}

export default CaseStudy